
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Agent from './pages/agent';
import Staff from './pages/Staff';
import Agency from './pages/Agency';
import AgentDetails from './pages/AgentDetails';
import Collections from './pages/Collections';
import IdleTimeOutHandler from './components/idleTimeContainer';
import Login from './pages/login';
import { store } from './redux';
import { Provider } from 'react-redux';
import ChangePwd from './pages/changePwd';
import Customer from './pages/Customer';
import Invoices from './pages/Invoices';
import DetailsInvoiceAgent from './pages/DetailsInvoiceAgent';
import AccountingOpWallet from './pages/AccountingOpWallet';
import BillerDetails from './pages/BillerDetails';
import CustomerDetails from './pages/CustomerDetails';
import DetailsInvoiceAgentStaff from './pages/DetailsInvoiceAgentStaff';
import UserLogs from './pages/UserLogs';
import DepotPerAgent from './pages/DepotPerAgent';
import BillerPerAgent from './pages/BillerPerAgent';
import AgentBalance from './pages/AgentBalance';
import AgencyUserOfAgency from './pages/AgencyUserOfAgency';
import MasterDepositByAgency from './pages/MasterDepositByAgency';
import AgencyDetails from './pages/AgencyDetails';
import AgentsOfAgency from './pages/AgentsOfAgency';
import CustomerDetailsOfAgency from './pages/CustomerDetailsOfAgency';
import DetailsInvoiceAgentOfAgency from './pages/DetailsInvoiceAgentOfAgency';
import PageNoteFound from './pages/PageNoteFound';
import PaymentMethod from './pages/PaymentMethod';
import LimitPerPaymentMethod from './pages/LimitPerPaymentMethod';
import ChangePwdUserAgency from './pages/changePwdUserAgency';
import AgencyUserLogin from './pages/AgencyUserLogin';
import DepotPerAgency from './pages/DepotPerAgency';
import AgencyBalance from './pages/AgencyBalance';
import BillerPerPaymentMode from './pages/BillerPerPaymentMode';
import SystemLogs from './pages/SystemLogs';
import ApiGroup from './pages/ApiGroup';
import ApiRecords from './pages/ApiRecords';
import BillerGroup from './pages/BillerGroup';

function App() {
  return (
    <>
    <Provider store={store}>

    <BrowserRouter>
    
      <Routes>
        <Route  path="/backoffice/login" element={<Login/>}></Route>
        <Route  path="/home" element={<Home/>}></Route>
        <Route  path="/agents" element={<Agent/>}></Route>
        <Route  path="/customers" element={<Customer/>}></Route>
        <Route  path="/staff" element={<Staff/>}></Route>
        <Route  path="/invoices" element={<Invoices/>}></Route>
        <Route  path="/payment-methods" element={<PaymentMethod/>}></Route>
        <Route  path="/limit-per-payment-methods" element={<LimitPerPaymentMethod/>}></Route>
        <Route  path="/masterDepositByAgency" element={<MasterDepositByAgency/>}></Route>
        <Route  path="/invoiceagent/:id" element={<DetailsInvoiceAgent/>}></Route>
        <Route  path="/agencyUserOfAgency/:id" element={<AgencyUserOfAgency/>}></Route>
        <Route  path="/customers/:id" element={<CustomerDetails/>}></Route>
        <Route path="/accountingOpByCustomer/:id" element={<AccountingOpWallet />}></Route>
        <Route path="/biller/:id" element={<BillerDetails />}></Route>
        <Route path="/invoiceStartupMaster/:id" element={<DetailsInvoiceAgentStaff />}></Route>
        <Route  path="/agencies" element={<Agency/>}></Route>
        <Route  path="/userLogs" element={<UserLogs/>}></Route>
        <Route  path="/system-logs" element={<SystemLogs/>}></Route>
        <Route  path="/api-group" element={<ApiGroup/>}></Route>
        <Route  path="/api-records/:apiTypeId" element={<ApiRecords/>}></Route>
        <Route  path="/billerPerAgent" element={<BillerPerAgent/>}></Route>
        <Route  path="/billerPerPaymentMode" element={<BillerPerPaymentMode/>}></Route>
        <Route  path="/billerGroup" element={<BillerGroup/>}></Route>
        <Route  path="/depotPerAgent" element={<DepotPerAgent/>}></Route> 
        <Route  path="/depot-per-agency" element={<DepotPerAgency/>}></Route>
        <Route  path="/agentBalance" element={<AgentBalance/>}></Route> 
        <Route  path="/agency-balance" element={<AgencyBalance/>}></Route> 
        <Route  path="/agent/:id" element={<AgentDetails/>}></Route>
        <Route  path="/agencies/:id" element={<AgencyDetails/>}></Route>
        <Route  path="/collections" element={<Collections/>}></Route>
        <Route  path="/change-password" element={<ChangePwd/>}></Route>
        <Route  path="/agency-change-password" element={<ChangePwdUserAgency/>}></Route>
        <Route  path="/collections/:idAgent/byAgent" element={<Collections/>}></Route>
        <Route  path="/collections/:idAgency/byAgency" element={<Collections/>}></Route>

        <Route  path="/agentsOfAgency" element={<AgentsOfAgency/>}></Route>
        <Route  path="/agency-user-login" element={<AgencyUserLogin/>}></Route>
        <Route  path="/customersOfAgency/:id" element={<CustomerDetailsOfAgency/>}></Route>
        <Route path="/invoiceStartupMasterOfAgency/:id" element={<DetailsInvoiceAgentOfAgency />}></Route>
        <Route path="*" element={<PageNoteFound/>}></Route>
        
        
        
      </Routes>
    </BrowserRouter>
    </Provider>
    
    </>

  );
}

export default App;
